import type {BoardSeat} from "../types/board-seat";

type BoardSeatContext = {
  board_seats?: BoardSeat[];
};

export function hasActiveBoardSeatForProperty(
  me: BoardSeatContext | null | undefined,
  propertyId: number | string | null | undefined,
): boolean {
  if (!me?.board_seats?.length || propertyId == null) return false;
  return me.board_seats.some((seat) => String(seat.property_id) === String(propertyId));
}
